var map = {
	"./audio.svg": "5b8d",
	"./course.svg": "71c5",
	"./deal.svg": "c580",
	"./excel.svg": "6599",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./ppt.svg": "0e4c",
	"./record.svg": "b3a3",
	"./setting.svg": "05ff",
	"./user.svg": "b3b5",
	"./username.svg": "c590",
	"./view.svg": "bb9c",
	"./voice.svg": "3f0e",
	"./word.svg": "bcb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";